module.exports = __webpack_public_path__ + "static/media/acerta_logo.4adb02f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/integrations_logos/acerta_logo.png
// module id = 299
// module chunks = 0